import { computed, defineComponent, PropType, ref } from "vue";
import SmeLayout from "../../layouts/SmeLayout";
import UploadBox from "../../components/UploadBox";
import Utils from "../../utils/Utils";
import SmeSupportForm from "../../components/SmeSupportForm";
import { SmeOrderJson } from "../../utils/SmeUtils";
import SmeContactBox from "../../components/SmeContactBox";
import OfferBox from "../../components/OfferBox";
import FormInfo from "../../components/FormInfo";
import Dialog from "../../utils/Dialog";

export default defineComponent({
    components: {
        SmeLayout,
        UploadBox,
        SmeSupportForm,
        SmeContactBox,
        OfferBox,
        FormInfo,
        Dialog,
    },

    template: `
        <SmeLayout>
            <h1 class="title-1">Na fakturze brakuje numeru NIP</h1>

            <SmeContactBox title="Na podstawie udostępnionej przez Ciebie faktury możemy zaproponować Ci jedynie ofertę dla domu." content="Jeśli szukasz oferty dla firmy, możesz spróbować wgrać inną fakturę." :button="false" :button2="true" button2_label="Wgraj inną fakturę" @click:button2="onUploadClick" />

            <div class="StepSmeNoNip__inner">
                <div class="StepSmeNoNip__offer">
                    <OfferBox
                        v-if="options.recooffer"
                        :offer="options.recooffer"

                        label_select="Sprawdź ofertę"
                        :select_disabled="selectdisabled"

                        sticky="auto"
                        :layout_variant="true"

                        @click="onOfferSelect"
                    />

                    <div class="StepSmeNoNip__all desktop">
                        <a href="/oferty" class="button button--secondary button--full">Zobacz wszystkie oferty dla domu</a>
                    </div>
                </div>

                <div class="StepSmeNoNip__body">
                    <div class="StepSmeNoNip__details contentbox contentbox--white">
                        <h2 class="title-2">Szczegóły naszej oferty</h2>

                        <FormInfo title="Taryfa" :value="options.recooffer.tariff" />
                        <FormInfo title="Stawka za kWh" :value="priceformat" />
                        <FormInfo title="Opłata handlowa" value="od 4,99 zł" />
                        <FormInfo title="Okres rozliczeniowy" value="1 miesiąc" />
                        <FormInfo title="Okres wypowiedznia umowy" value="1 miesiąc" />
                    </div>

                    <div class="StepSmeNoNip__all mobile">
                        <a href="/oferty" class="button button--secondary button--full">Zobacz wszystkie oferty dla domu</a>
                    </div>

                    <div class="StepUpload__box mobile">
                        <h2>Wgraj inną fakturę swojej firmy</h2>

                        <p>Faktura Twojej firmy powinna zawierać numer NIP. Dzięki danym, które odczytamy z faktury <b>będziemy mogli zaproponować Ci najlepszą możliwą ofertę.</b></p>

                        <UploadBox
                            :options="options"
                            :sme="true"

                            label_upload_mobile="Wgraj fakturę Twojej firmy"

                            @back="false"
                            @next="onUploadSubmit"

                            :visible_back="true"
                        />
                    </div>

                    <SmeContactBox class="smallbuttons" :button="false" :button3="true" button3_label="Zamów rozmowę" @click:button3="onContactClick" />
                </div>
            </div>
        </SmeLayout>

        <Dialog ref="dialog_upload" class="SmeDialog" title="Chcesz wgrać inną fakturę?">
            <p>Faktura Twojej firmy powinna zawierać numer NIP. Dzięki danym, które odczytamy z faktury <b>będziemy mogli zaproponować Ci najlepszą możliwą ofertę.</b></p>

            <UploadBox
                :options="options"
                :sme="true"

                label_upload_mobile="Wgraj fakturę Twojej firmy"

                @back="dialog_usage.close()"
                @next="onUploadSubmit"

                :visible_back="true"
            />
        </Dialog>

        <Dialog ref="dialog_contact" class="SmeDialog" title="Chcesz dowiedzieć się więcej?">
            <SmeSupportForm type="offer">
                <p class="SmeSupportFormBox__text">Jeśli masz pytania albo potrzebujesz pomocy, wypełnij formularz. Nasz Doradca skontaktuje się z Tobą, aby dopasować najlepszą ofertę dla Twojej firmy.</p>
            </SmeSupportForm>
        </Dialog>
    `,

    emits: [
        'offers',
        'b2c',
    ],

    props: {
        options: { type: Object as PropType<SmeOrderJson>, required: true },
    },

    setup(props, ctx) {
        const dialog_upload = ref(null);
        const dialog_contact = ref(null);

        const priceformat = computed(() => {
            return Utils.priceFormat(props.options.recooffer?.prices[0].price, false, ' zł', 4);
        });

        function onUploadClick() {
            if (window.innerWidth < 769) {
                Utils.scrollToEl($('.StepUpload__box'));
            } else {
                dialog_upload.value.show();
            }
        }

        function onContactClick(e: MouseEvent) {
            dialog_contact.value.show();
        }

        async function onOfferSelect(offer) {
            await Utils.setCart('offer.b2c', {
                offer_id: offer.id,
            });

            ctx.emit('b2c');
        }

        function onUploadSubmit() {
            Utils.setStep(props.options.nextstep);
        }

        Utils.attachBodyClass(['StepSmeNoNip']);

        return {
            dialog_upload,
            dialog_contact,

            priceformat,

            onUploadClick,
            onContactClick,
            onOfferSelect,
            onUploadSubmit,
        };
    },
});
